// Competition and alternatives section configuration
// Defines fields for competitive landscape analysis
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for competition section
export const competitionSectionSchema = z.object({
  mainCompetitors: z.string().min(1, 'Este campo es requerido'),
  currentAlternatives: z.string().min(1, 'Este campo es requerido'),
  competitiveAdvantage: z.string().min(1, 'Este campo es requerido'),
});

export type CompetitionSectionData = z.infer<typeof competitionSectionSchema>;

// Section config
export const competitionSection: SectionConfig = {
  id: 'competition',
  titleKey: 'Competencia y alternativas',
  descriptionKey: 'Analiza tu competencia y ventajas competitivas',
  validationSchema: competitionSectionSchema,
  fields: [
    {
      name: 'mainCompetitors',
      type: 'textarea',
      label: '¿Quiénes son tus principales competidores?',
      placeholder: 'Lista tus competidores directos e indirectos...',
      required: true,
    },
    {
      name: 'currentAlternatives',
      type: 'textarea',
      label: '¿Qué alternativas existen hoy?',
      placeholder: 'Describe las soluciones alternativas disponibles...',
      required: true,
    },
    {
      name: 'competitiveAdvantage',
      type: 'textarea',
      label: '¿Cuál es tu ventaja frente a ellos?',
      placeholder: 'Explica tu diferenciación competitiva...',
      required: true,
    },
  ],
};
